import React, { Component, useState, useEffect } from "react";
import "./App.css";
import Nav from "./Components/Nav";
import { BrowserRouter as Router, Link, Switch } from "react-router-dom";
import Hero from "./Components/Hero/Hero";
import Skills from "./Components/Skills/Skills";
import About from "./Components/About/About";
import Projects from "./Components/Projects/Projects";
import Contact from "./Components/Contact/Contact";
import Footer from "./Components/Footer/Footer";
import Loader from "react-loader-spinner";

function App() {
  const [preloader, setPreloader] = useState(true);
  useEffect(() => {
    setTimeout(() => {
      setPreloader(false);
    }, 4000);
  }, []);

  return (
    <Router>
      <div className="App">
        {preloader ? (
          <div className="loader">
            <Loader
              type="BallTriangle"
              color="#845ec2"
              height={100}
              width={100}
            />
          </div>
        ) : (
          <div>
            <Nav />
            <Hero />
            <About />
            <Skills />
            <Projects />
            <Contact />
            <Footer />
          </div>
        )}
      </div>
    </Router>
  );
}

export default App;
